module.exports = __webpack_public_path__ + "static/media/Gallery-19.498a6b78.jpg";